import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class OverviewService extends BaseService{

  constructor() {
    super();
  }

  getTopRetailers(type, startDate, endDate):Observable<any>{
    let url = APIUrl.topRechargees;
    let params = new HttpParams().set('type', type).set('startDate', startDate).set('endDate', endDate)
    return this.httpService.getParams(url, params);
  }
}
